// Node
import { cookieBannerInit } from '../../../../assets/javascripts/new_design/common/cookie_banner';

const $ = require('jquery');

// Vendor
import * as select from '@material/select/index';
import * as textField from '@material/textfield/index';
import { authInit, initAuthAction } from 'new_design/common/auth';
import { initFavorite } from 'new_design/common/favorite';
import { leadCatcher } from 'new_design/common/lead_catcher';
import { MTUIInit } from 'new_design/common/mtui/mtui';
import { preventEmptyHrefDefault } from 'new_design/common/prevent_empty_href_default';
import { openPopupById, popupInit } from 'new_design/desktop/common/popup';
// require('new_design/mdc.formField.min');

// Custom
require('common/noty_notifications');
require('new_design/common/funny-sad-dialog');

require('common/polyfills');

$(function () {
  window.isMobileDevice = false;

  btnClickColor();
  materialFormsInit(); // TODO: move out there

  popupInit();
  authInit();
  MTUIInit();

  preventEmptyHrefDefault();

  loadAdminElements();

  // Метрика на кнопку заявки на подбор
  $('.btn_new_bid').on('click', () => {
    window.ymReachGoal('parting-form-metrika');
  });

  leadCatcher();
  cookieBannerInit();
  initFavorite();

  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('show_login')) {
    openPopupById('auth-popup');
  }

  document.addEventListener('client_is_checked', initAuthAction);
});

function loadAdminElements() {
  fetch(`/helpers/admin_elements?url=${location.href}`)
    .then((response) => {
      return response.text();
    })
    .then((data) => {
      $('#admin_elements').html(data);
    })
    .catch((e) => {
      console.log(e);
    });
}

// TODO: replace with pure-CSS solution (https://codepen.io/finnhvman/pen/jLXKJw)
function btnClickColor() {
  document.querySelectorAll('.btn_color, .btn_form, .btn_border, .btn_gradient, .btn_sub').forEach(function (b) {
    return b.addEventListener('click', function (e) {
      let s;
      requestAnimationFrame(draw);

      function draw(t) {
        t - (s = s || t) < 1000 && requestAnimationFrame(draw);
        t = (t - s) / 500;
        let r = b.getBoundingClientRect();
        let p = ''
          .concat(e.x - r.x, ' ')
          .concat(e.y - r.y, ',')
          .concat(t * Math.max(r.width, r.height));
        b.style.backgroundImage = '-webkit-gradient(radial,'
          .concat(p, ',')
          .concat(p, ',from(rgba(255,255,255,')
          .concat(0.6 - t * 0.6, ')),to(#fff0))');
      }
    });
  });
}

// TODO: move out there
function materialFormsInit() {
  $('.mdc-text-field').each(function (i, obj) {
    textField.MDCTextField.attachTo(obj);
  });
  $('.mdc-select').each(function (i, obj) {
    select.MDCSelect.attachTo(obj);
  });
}
